import React from 'react';

export default function DropdownIcon(props) {
  return (
    <img src="/assets/files/questions/dropdown.svg" alt="dropdown" {...props} />
  );
}
